import { render, staticRenderFns } from "./ProductDigitalDownload.vue?vue&type=template&id=450421c7&scoped=true&"
import script from "./ProductDigitalDownload.vue?vue&type=script&lang=ts&"
export * from "./ProductDigitalDownload.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDigitalDownload.vue?vue&type=style&index=0&id=450421c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450421c7",
  null
  
)

export default component.exports